var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_329_8023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.28516 10H19.2852",
    stroke: "white",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4277 7.14282L19.2849 9.99996L16.4277 12.8571",
    stroke: "white",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7138 16.4142C15.4311 17.7513 13.7776 18.674 11.9661 19.0637C10.1546 19.4534 8.26795 19.2922 6.54881 18.6009C4.82968 17.9096 3.35668 16.7198 2.31929 15.1845C1.28189 13.6492 0.727539 11.8386 0.727539 9.98567C0.727539 8.13274 1.28189 6.32219 2.31929 4.78689C3.35668 3.25159 4.82968 2.06176 6.54881 1.37044C8.26795 0.679126 10.1546 0.517942 11.9661 0.907621C13.7776 1.2973 15.4311 2.22002 16.7138 3.5571",
    stroke: "white",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_8023"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fcc0321c5c3efb7cd7162d42a75eac0e.svg";
export { ForwardRef as ReactComponent };